import { cn } from '@/lib/utils';


// ============================================================================
// SURVIVOR STATUS BANNER
// ============================================================================

/**
 * Survivor banner — rendered only when it adds signal beyond the header stat
 * (dedupe, user feedback 2026-07-17):
 *   ELIMINATED — the oxblood state card (status + week + spectate note).
 *   ALIVE      — shown ONLY when the entrant has no pick this week; renders a
 *                gold "make your pick" nudge without restating ALIVE (the
 *                header stat already carries status + weeks survived, and the
 *                countdown line carries the pick once one is saved).
 */
export function SurvivorStatusBanner({
  status,
  weeksSurvived,
  eliminatedWeek,
}: {
  status: 'ALIVE' | 'ELIMINATED';
  weeksSurvived: number;
  eliminatedWeek: number | null;
  /** Retained for call-site compat; the alive-with-pick state no longer renders. */
  currentPickTeam?: string | null;
  currentPickLocked?: boolean;
}) {
  const weeksLabel = `${weeksSurvived} week${weeksSurvived === 1 ? '' : 's'}`;

  if (status === 'ALIVE') {
    // No-pick nudge (the caller gates on "no saved pick this week").
    return (
      <div className="rounded-xl border border-gold/30 bg-surface-2 p-3 mb-6">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <span className="text-sm font-bold text-gold">Make your pick</span>
          <span className="text-xs text-warm-gray">
            One team to win — you can never use a team twice.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-oxblood/30 bg-surface-2 p-3 mb-6">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-xl font-bold font-serif text-oxblood-text">ELIMINATED</span>
          <span className="text-xs text-warm-gray">in {eliminatedWeek != null && eliminatedWeek > 0 ? `Week ${eliminatedWeek}` : 'the preseason'}</span>
        </div>
        <span className={cn('text-xs text-warm-gray')}>
          survived {weeksLabel} — you can still follow the pool
        </span>
      </div>
    </div>
  );
}
